export const NO_UE_CAP = 1_000_000
